import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useLang } from '../../i18n/LangContext';

export default function Hero() {
  const { t } = useLang();
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="relative min-h-screen overflow-hidden">
      <div className="absolute inset-0">
        <img src="https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?w=1920&q=80"
          alt="Modern luxury home with pool at dusk" className="w-full h-full object-cover" />
        {/* Lighter center so the house stays visible; darker at top (badge) and bottom (headline) for legibility */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/15 to-[#0B0D0F]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />
      </div>
      <div className="relative z-10 min-h-screen max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-between pt-24 pb-14 sm:pt-28 sm:pb-20">
        {/* Top — badge in the sky */}
        <div className="flex justify-center sm:justify-start">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/40 bg-black/30 backdrop-blur-sm">
            <span className="text-[#D4AF37] text-xs sm:text-sm font-mono tracking-[0.2em] uppercase">{t.hero.badge}</span>
          </div>
        </div>
        {/* Bottom — headline, description & CTAs near the pool */}
        <div className="max-w-3xl">
          <h1 className="text-xl sm:text-2xl lg:text-3xl text-white font-light mb-4 font-outfit tracking-wide drop-shadow-lg">{t.hero.tagline}</h1>
          <p className="text-base sm:text-lg text-slate-200 max-w-xl mb-8 leading-relaxed drop-shadow">{t.hero.desc}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button onClick={() => scrollTo('#estimate')} data-testid="hero-estimate-cta"
              className="group flex items-center justify-center gap-3 bg-[#D4AF37] hover:bg-[#E5C158] text-black font-bold px-8 py-4 rounded text-base transition-all">
              {t.hero.cta1}<ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={() => scrollTo('#visualizer')} data-testid="hero-visualize-cta"
              className="group flex items-center justify-center gap-3 border border-white/40 hover:border-white/70 text-white font-semibold px-8 py-4 rounded text-base transition-all hover:bg-white/5 bg-black/20 backdrop-blur-sm">
              <Sparkles className="w-5 h-5" />{t.hero.cta2}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
